// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1ZjTb","right":"styles_right__15giw"};